import { FaMapMarkerAlt, FaClock, FaPhone, FaEnvelope, FaWhatsapp, FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import CARRO from "../assets/contactcar.png";

const Contactanos = () => {
  const info = [
    {
      icon: <FaMapMarkerAlt className="text-sky-600 text-xl" />,
      info: "Calle. 51 Poniente No. 110, Col. Prados Agua Azul, C.P. 72430, México, Puebla.",
    },
    {
      icon: <FaClock className="text-sky-600 text-xl" />,
      info: "Lun - Sáb 9:00 - 17:00 Domingo Cerrado",
    },
    {
      icon: <FaPhone className="text-sky-600 text-xl" />,
      info: "222 200 8962",
    },
    {
      icon: <FaEnvelope className="text-sky-600 text-xl" />,
      info: "loginem.1510@gmail.com",
    },
  ];

  const redes = [
    { icon: <FaWhatsapp />, url: "https://api.whatsapp.com/send/?phone=%2B522222008962&text&type=phone_number&app_absent=0" },
    { icon: <FaFacebook />, url: "https://www.facebook.com/profile.php?id=100076158990580#" },
    { icon: <FaInstagram />, url: "https://www.instagram.com/loginem.1510/" },
    { icon: <FaLinkedin />, url: "https://www.linkedin.com/in/loginem-logistica-integral-empresarial-14b106214/" },
  ];

  return (
    <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6 p-4 md:p-12">
      {/* Columna de info */}
      <div className="flex flex-col justify-center gap-6">
        <h2 className="text-2xl text-sky-800 font-bold mb-4">Contáctanos</h2>

        {/* Info con icono + texto */}
        <div className="flex flex-col gap-4">
          {info.map((item, i) => (
            <div key={i} className="flex items-center gap-3 text-gray-700">
              {item.icon}
              <span>{item.info}</span>
            </div>
          ))}
        </div>

        {/* Redes sociales */}
        <div className="flex gap-4 pt-4 text-sky-600 text-2xl">
          {redes.map((r, i) => (
            <a
              key={i}
              href={r.url}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-sky-800 transition-colors"
            >
              {r.icon}
            </a>
          ))}
        </div>
      </div>

      {/* Columna de imagen */}
      <div className="flex items-center justify-center">
        <img src={CARRO} className="w-64 md:w-80" alt="camion contacto" />
      </div>

      {/* Columna de mapa */}
      <div className="w-full h-64 md:h-auto">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3771.5637747920664!2d-98.2471700251406!3d19.038934582158056!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85cfc7178caa5839%3A0xa1595ea6818d4f6a!2sLOGINEM!5e0!3m2!1ses-419!2smx!4v1755819679943!5m2!1ses-419!2smx"
          title="LOGINEM"
          className="w-full h-full rounded-lg shadow-md"
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </div>
  );
};

export default Contactanos;
